import { Settings } from "../models/settings";

export const defaultSettings: Settings = {
    maximumNumberOfCards: 7
}